<template>
  <div style="font-size: 0;">
    <div class="disable-hint" v-if="showDisable">
      <div class="disable-hint-content">
        <div class="disable-label">{{ disableLabel }}</div>
        <div class="disable-value">{{ disableValue }}</div>
      </div>
    </div>
    <div class="footer-content">
      <div class="footer">
        <div class="btn" :class="{ 'disable-ash': disable, 'grey' : showDisable }" @click="save">{{ btnText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      btnText: {
        type: String,
        default: '保存'
      },
      disableLabel: {
        type: String,
        default: ''
      },
      disableValue: {
        type: String,
        default: '比赛已开始，无法更新出场信息'
    },
      showDisable: {
        type: Boolean,
        default: false
      },
      disable: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {

        };
    },
    methods: {
      save() {
        if (this.disable) {
          return
        }
        this.$emit('click')
      }
    },
};
</script>

<style scoped lang="scss">
.disable-hint{
  height: 40px;
  padding: 0 12px;

  .disable-hint-content{
    position: fixed;
    bottom: 88px;
    height: 40px;
    width: calc(100vw - 24px);
    box-sizing: border-box;
    height: 31px;
    border-radius: 2px;
    background: #F9EAE8;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    .disable-label{
      color: #1D2129;
      margin-right: 10px;
    }
    .disable-value{
      color: #73767A;
    }
  }
}
.footer-content{
  height: 80px;
  .disable-ash{
    opacity: 0.5;
  }
  .grey{
    opacity: 0.7;
  }
}
.footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 0 16px;
    background-color: #F8F8F8;
    .btn{
        height: 47px;
        border-radius: 6px;
        line-height: 47px;
        text-align: center;
        background: #0FAC7F;
        color: #FFFFFF;
        font-size: 16px;
        font-weight: 500;
    }
}
</style>
